// removed by extract-text-webpack-plugin
module.exports = {"view":"style__view___Ft76T","title":"style__title___3mpKs","date":"style__date___31MvN","subtitle":"style__subtitle___XoBVc","text":"style__text___33zfM","textTitle":"style__textTitle___3JjtI","link":"style__link___2vmNS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/acceptence/style.css
// module id = 121
// module chunks = 0